import { useState, useEffect } from 'react';
import client from '../api/client';

export default function useRecoveryData() {
  const [surgeryProfile, setSurgeryProfile] = useState(null);
  const [milestones, setMilestones] = useState([]);
  const [activeMeds, setActiveMeds] = useState([]);
  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [activeDevices, setActiveDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  const hasSurgeryProfile = surgeryProfile !== null;

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [profileRes, milestonesRes, medsRes, apptsRes, devicesRes] = await Promise.all([
        client.get('/recovery/surgery-profile').catch(() => ({ data: null, status: 204 })),
        client.get('/recovery/milestones').catch(() => ({ data: [] })),
        client.get('/recovery/medications/active').catch(() => ({ data: [] })),
        client.get('/recovery/appointments/upcoming').catch(() => ({ data: [] })),
        client.get('/recovery/drain-catheters', { params: { active: true } }).catch(() => ({ data: [] })),
      ]);

      setSurgeryProfile(profileRes.status === 204 ? null : profileRes.data);
      setMilestones(milestonesRes.data || []);
      setActiveMeds(medsRes.data || []);
      setUpcomingAppointments(apptsRes.data || []);
      setActiveDevices(devicesRes.data || []);
    } catch {
      // silently fail
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAll(); }, []);

  return {
    surgeryProfile,
    milestones,
    activeMeds,
    upcomingAppointments,
    activeDevices,
    hasSurgeryProfile,
    loading,
    refresh: fetchAll,
  };
}
